import { RetinaContext, defaultRetinaContext } from "../../../context/retina.context";
import { jsx as _jsx } from "react/jsx-runtime";
export var RetinaProvider = function RetinaProvider(_ref) {
  var children = _ref.children,
    _ref$retinaEnabled = _ref.retinaEnabled,
    retinaEnabled = _ref$retinaEnabled === void 0 ? defaultRetinaContext : _ref$retinaEnabled;
  return /*#__PURE__*/_jsx(RetinaContext.Provider, {
    value: retinaEnabled,
    children: children
  });
};